import { render, staticRenderFns } from "./BotonesPreventa.vue?vue&type=template&id=5472f629&scoped=true"
import script from "./BotonesPreventa.vue?vue&type=script&setup=true&lang=js"
export * from "./BotonesPreventa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BotonesPreventa.vue?vue&type=style&index=0&id=5472f629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472f629",
  null
  
)

export default component.exports